import { SxProps, Theme } from '@mui/system';

const styles = {
  question: {
    color: 'primary.inputLabel',
    fontSize: 14,
    fontWeight: 500,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
